import { render, staticRenderFns } from "./DAF.vue?vue&type=template&id=15a4a6f8&scoped=true&"
import script from "./DAF.vue?vue&type=script&lang=js&"
export * from "./DAF.vue?vue&type=script&lang=js&"
import style0 from "./DAF.vue?vue&type=style&index=0&id=15a4a6f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a4a6f8",
  null
  
)

export default component.exports